import universal from 'react-universal-component';

export default universal(() => import('./Top200'));



// WEBPACK FOOTER //
// ./src/app/views/Top200/index.js